// Importiere die benötigten Funktionen aus dem Firebase SDK
import { initializeApp } from "firebase/app";
import {
    initializeAuth,
    getAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence,
    browserPopupRedirectResolver,
} from "firebase/auth";
import { getFirestore, initializeFirestore, memoryLocalCache, collection, addDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Importiere Storage
import { serverTimestamp } from "firebase/firestore"; // Importiere serverTimestamp

// Deine Firebase-Konfiguration
const firebaseConfig = {
    apiKey: "AIzaSyAn8JBfLX8DW2Gzp7CoIMvNSH8Se4Qvgjg",
    authDomain: "jewlai2.firebaseapp.com",
    projectId: "jewlai2",
    storageBucket: "jewlai2.appspot.com",
    messagingSenderId: "119717394273",
    appId: "1:119717394273:web:0747584d81391fd01e3720"
};

// Initialisiere Firebase
const app = initializeApp(firebaseConfig);

// Persistence einmal beim Init setzen — setPersistence() danach
// kann die Session beim Reload kurz auf null setzen.
let auth;
try {
    auth = initializeAuth(app, {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
        popupRedirectResolver: browserPopupRedirectResolver,
    });
} catch (_) {
    auth = getAuth(app);
}

// Memory-Cache: IndexedDB-Persistence + enableNetwork/disableNetwork
// hat den Client in "INTERNAL ASSERTION FAILED: Unexpected state" gebracht.
let firestore;
try {
    firestore = initializeFirestore(app, { localCache: memoryLocalCache() });
} catch (_) {
    firestore = getFirestore(app);
}

// Initialisiere Storage
const storage = getStorage(app);

// Exportiere die Instanzen für die Verwendung in anderen Teilen der Anwendung
export { auth, firestore, storage, collection, addDoc, serverTimestamp }; // Füge serverTimestamp zum Export hinzu
